import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemConfigurationModels } from '../models/system-configuration.model';
import { api } from '../consts/url';

@Injectable({ providedIn: 'root' })
export class SystemConfigurationService {
  private readonly httpClient = inject(HttpClient);

  public get(): Observable<SystemConfigurationModels.Document | null> {
    return this.httpClient.get<SystemConfigurationModels.Document | null>(api.systemConfiguration.crud);
  }

  public save(body: SystemConfigurationModels.UpdateDto): Observable<SystemConfigurationModels.Document> {
    return this.httpClient.put<SystemConfigurationModels.Document>(api.systemConfiguration.crud, body);
  }
}
